import { createSlice } from '@reduxjs/toolkit'
import { LOCATION_CHANGE } from 'connected-react-router'

import api, { createWrappedAsyncThunk } from 'src/api'

import { fetchUnreadConversationsCount } from '../messages/slice'

const SLICE_NAME = 'app'

export const fetchUnreadNotificationsCount = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchUnreadNotificationsCount`,
  () => api.get(`/notifications/unread_count/`)
)

export const fetchNotifications = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchNotifications`,
  () => api.get(`/notifications/`)
)

export const markNotificationsRead = createWrappedAsyncThunk(
  `${SLICE_NAME}/markNotificationsRead`,
  () => api.post(`/notifications/mark_read/`)
)

const initialState = {
  lastPage: '',
  thisPage: '',
  notifications: [],
  unreadConversations: 0,
  unreadNotifications: 0,
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    [LOCATION_CHANGE]: (state, { payload }) => {
      const { thisPage } = state
      const { pathname } = payload.location
      if (thisPage !== pathname) {
        state.lastPage = thisPage
        state.thisPage = pathname
      }
      return state
    },
    [fetchUnreadConversationsCount.fulfilled]: (state, { payload }) => {
      const { unreadConversations } = payload
      state.unreadConversations = unreadConversations
      return state
    },
    [fetchUnreadNotificationsCount.fulfilled]: (state, { payload }) => {
      const { unreadNotifications } = payload
      state.unreadNotifications = unreadNotifications
      return state
    },
    [fetchNotifications.fulfilled]: (state, { payload }) => {
      state.notifications = payload.results
      return state
    },
    [markNotificationsRead.fulfilled]: (state, { payload }) => {
      state.unreadNotifications = 0
      state.notifications.forEach(n => (n.read = true))
      return state
    },
  },
})

export default slice.reducer
